module.exports = __webpack_public_path__ + "img/badge-team-darkbg.5cebba5f.svg";